<template>
  <input ref="inputRef" :class="`${'form-control text-right'} ${className}`" :autocomplete="autocomplete" />
</template>

<script>
import { watch } from '@vue/composition-api';
import { useCurrencyInput } from 'vue-currency-input';

export default {
  name: 'CurrencyInput',
  props: {
    value: [Number, String],
    options: {
      default() {
        return {
          currency: 'BRL',
          locale: this.$i18n.locale,
          currencyDisplay: 'hidden',
          precision: 2,
          autoDecimalDigits: true
        };
      },
      type: Object
    },
    className: [String, Object],
    optionsForm: Object,
    allowNegative: {
      type: Boolean,
      default: true
    },
    autocomplete: null
  },
  setup(props) {
    const { inputRef, setOptions, setValue } = useCurrencyInput({ ...props.options, ...props.optionsForm });

    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (!props.allowNegative && newValue < 0) {
          setValue(oldValue);
        } else {
          setValue(newValue);
        }
      }
    );

    watch(
      () => props.options,
      (options) => {
        setOptions(options);
      }
    );

    return { inputRef };
  }
};
</script>
